
class JournalEntryHeaderView extends UITableViewCell
{
    private indexLabel:MUILabel = null;
    private dateLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;

    private df = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).dateFormatter;

    awakeFromHTML()
    {
        this.indexLabel = MUIOutlet(this, "index-lbl", "MUILabel");
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:AccountingJournalEntry = null;
    set item(item:AccountingJournalEntry)
    {
        this._item = item;

        if (this.indexLabel) this.indexLabel.text = "#" + (item.journalIndex ?? "");
        if (this.dateLabel) this.dateLabel.text = item.date ? this.df.stringFromDate(item.date) : "";
        if (this.conceptLabel) this.conceptLabel.text = (item as any).linkedEntityConcept ?? "";
    }
}
